import { useState, MouseEvent } from 'react';

export const useMenu = () => {
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenuOpen = (event: MouseEvent<any>) => {
    setMenuAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };

  return { menuAnchorEl, handleMenuOpen, handleMenuClose };
};
